import { render, staticRenderFns } from "./PaymentGateway.vue?vue&type=template&id=e8fe6bf4"
import script from "./PaymentGateway.vue?vue&type=script&lang=js"
export * from "./PaymentGateway.vue?vue&type=script&lang=js"
import style0 from "./PaymentGateway.vue?vue&type=style&index=0&id=e8fe6bf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports